import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  CircularProgress,
  Badge,
  Tooltip,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
const emptyItemData = {
  email_discussion: "",
};
export default function ItemDialogTabEmail({ open, setOpen, onSubmit }) {
  const user = useSelector((state) => state.user);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    control,
    setError, // Add setError function
    reset,
    formState: { errors },
  } = useForm({ defaultValues: emptyItemData });

  const submit = (data) => {
    setLoader(true);
    onSubmit(data).then(() => {
      setLoader(false);
    });
  };

  // Use the clearStatusFieldError function when the dialog is opened
  useEffect(() => {
    if (open) {
      // Reset the form when the dialog is opened
      reset(emptyItemData);
    }
  }, [open, reset]);

  return (
    <Dialog
      open={open}
      onClose={() => {
        // setOpen(false);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ textTransform: "capitalize" }}>
        Please Fill up this form and submit your response
      </DialogTitle>
      <DialogContent>
        <Grid container width={500} spacing={1} py={1}>
          <Grid item xs={12}>
            <TextField
              label="Follow up communication"
              name="email_discussion"
              fullWidth
              multiline={true}
              rows={3}
              inputRef={register({
                required: false,
              })}
              // required
              error={Boolean(errors.email_discussion)}
              helperText={errors.email_discussion?.message}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpen(false);
          }}
          className="cancel-button"
        >
          Follow Up Not Done
        </Button>

        {loader ? (
          <div className="overlay">
            <Loading></Loading>
          </div>
        ) : (
          <Button
            disabled={/^Trial_User$/i.test(user.role) ? true : false}
            className="blue-button"
            onClick={handleSubmit(submit)}
          >
            Follow Up Done
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
function Loading() {
  return (
    <div className="page d-flex">
      <div className="m-auto text-center">
        <CircularProgress />
      </div>
    </div>
  );
}
